import { render, staticRenderFns } from "./addFormula.vue?vue&type=template&id=475cf122&scoped=true&"
import script from "./addFormula.vue?vue&type=script&lang=js&"
export * from "./addFormula.vue?vue&type=script&lang=js&"
import style0 from "./addFormula.vue?vue&type=style&index=0&id=475cf122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475cf122",
  null
  
)

export default component.exports